import { Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { ShieldCheck, Landmark, Star } from '@/components/ui/icons'
import { FONTS, SPACING, RADIUS, COLORS } from '@/lib/brand'
import { useSemanticColors } from '@/lib/theme/tokens'
import { useTheme } from '@/lib/hooks/use-theme'

export function HostRetentionCard() {
  const { t } = useTranslation()
  const { isDark } = useTheme()
  const colors = useSemanticColors(isDark)

  const points = [
    { icon: ShieldCheck, text: t('hosting.retention_point_coverage') },
    { icon: Landmark, text: t('hosting.retention_point_payout') },
    { icon: Star, text: t('hosting.retention_point_repeat') },
  ] as const

  return (
    <View
      testID="hosting.retention-banner"
      accessibilityRole="text"
      accessibilityLabel={t('hosting.retention_title')}
      style={{
        padding: SPACING.md,
        borderRadius: RADIUS.lg,
        borderWidth: 1,
        borderColor: colors.border,
        backgroundColor: colors.surface,
        gap: SPACING.sm,
      }}
    >
      <Text
        style={{
          fontSize: 12,
          fontFamily: FONTS.body,
          color: colors.textMuted,
          textTransform: 'uppercase',
          letterSpacing: 0.6,
        }}
      >
        {t('hosting.retention_kicker')}
      </Text>
      <Text
        style={{
          fontSize: 17,
          lineHeight: 24,
          fontFamily: FONTS.bodyBold,
          color: colors.textPrimary,
        }}
      >
        {t('hosting.retention_title')}
      </Text>
      <Text
        style={{
          fontSize: 14,
          lineHeight: 20,
          fontFamily: FONTS.body,
          color: colors.textSecondary,
        }}
      >
        {t('hosting.retention_body')}
      </Text>
      {points.map((point) => {
        const Icon = point.icon
        return (
          <View
            key={point.text}
            style={{ flexDirection: 'row', alignItems: 'center', gap: SPACING.sm }}
          >
            <Icon size={18} color={COLORS.coral.DEFAULT} strokeWidth={2} />
            <Text
              style={{
                flex: 1,
                fontSize: 14,
                lineHeight: 20,
                fontFamily: FONTS.body,
                color: colors.textPrimary,
              }}
            >
              {point.text}
            </Text>
          </View>
        )
      })}
    </View>
  )
}
